import { defineStore } from 'pinia'
import { ref } from 'vue'
import { v4 as uuidv4 } from 'uuid'

export const useSnackbarStore = defineStore('snackbar', () => {
  const snacks = ref<any>({})

  const getSnacks = () => snacks.value

  const addSnack = (snack: {}): string => {
    const uuid = uuidv4()

    snacks.value[uuid] = snack

    return uuid.toString()
  }

  const removeSnack = (uuid: string): void => {
    delete snacks.value[uuid]
  }

  const updateSnack = (uuid: string, snack: {}) => {
    snacks.value[uuid] = snack
  }

  return {
    getSnacks,
    addSnack,
    removeSnack,
    updateSnack,
  }
})